<ng-content></ng-content>
<div
  *ngIf="show"
  class="loading-backdrop overlay"
  [style.background]="backgroundColor()"
  (mousedown)="$event.stopPropagation()"
  (mouseup)="$event.stopPropagation()"
>
  <div class="panel panel-default loading-box">
    <div class="panel-body">
      <div class="loader overlay-loader"></div>
      Loading...
    </div>
  </div>
</div>
